import { Command, CommandHandler, DeleteResponse, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface OrderDeleteParams {
	orderId: string;
}

export class OrderDeleteCommand extends Command<OrderDeleteParams, DeleteResponse> { }

export class OrderDeleteCommandBase implements CommandHandler<OrderDeleteCommand, OrderDeleteParams, DeleteResponse> {
	private static Url = TaggedUrl.join('orders/:orderId', [Tags.SelloApi]);

	public constructor(
		private readonly http: HttpService
	) { }

	public async handleAsync(command: OrderDeleteCommand): Promise<DeleteResponse> {
		const url = fillPlaceholders(OrderDeleteCommandBase.Url, { orderId: command.params?.orderId });
		const { data } = await this.http.delete<DeleteResponse>(url);
		return data;
	}
}
